/*ěščřžýáíéúů*/

const cssVars = () => {
    const doc = document.documentElement;

    // Set site-header height
    doc.style.setProperty(
        "--site-header-height",
        $(".site-header").innerHeight() + "px",
    );

    // Set action-header height
    if (
        $(".action-header").length &&
        $(".action-header").css("display") !== "none"
    ) {
        doc.style.setProperty(
            "--action-header-height",
            $(".action-header").innerHeight() + "px",
        );
    } else {
        doc.style.setProperty("--action-header-height", "0px");
    }

    // Set adminbar height if it exists
    if ($("#wpadminbar").length) {
        doc.style.setProperty(
            "--adminbar-height",
            $("#wpadminbar").innerHeight() + "px",
        );
    } else {
        doc.style.setProperty("--adminbar-height", "0px");
    }
};
window.addEventListener("resize", cssVars);
cssVars();

var fancyboxCS = {
    cs: {
        CLOSE: "Zavřít",
        NEXT: "Další",
        PREV: "Přechozí",
        ERROR: "Požadovaný obsah se nepodařilo načíst. <br/>Pokuste se o to prosím později.",
        PLAY_START: "Spustit slideshow",
        PLAY_STOP: "Pozastavit slideshow",
        FULL_SCREEN: "Celá obrazovka",
        THUMBS: "Náhledy",
        DOWNLOAD: "Stáhnout",
        SHARE: "Sdílet",
        ZOOM: "Zvětšit",
    },
};

jQuery(document).ready(function ($) {
    window.$root = $("html, body");

    // iCheck
    /*$(
        "input[type='radio']:not(.without-icheck), input[type='checkbox']:not(.without-icheck)",
    ).iCheck({});*/

    // selectboxit
    //$('.gfield_select').selectBoxIt();

    // Gravity forms
    // - action when form loaded (e.g. on page load, after submit attempt)
    $(document).on(
        "gform_post_render",
        function (event, form_id, current_page) {
            // iCheck
            //$("input[type='radio'], input[type='checkbox']").iCheck({});

            // selectboxit
            // $('.gfield_select').selectBoxIt();

            // iCheck consent/checkbox click icheck fix
            /*$(".gfield--type-choice .icheckbox")
                .off("click")
                .on("click", function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    var $input = $(this).find("input");
                    $input.iCheck($input.is(":checked") ? "uncheck" : "check");
                    $input.trigger("change");
                });*/

            // Add class to form when submitting
            $("#gform_" + form_id).submit(function () {
                $("#gform_" + form_id).addClass("loading");
            });
        },
    );

    $.fancybox.defaults.hash = false;
    $.fancybox.defaults.loop = true;
    // fancybox images inside text content
    $("#textPage a")
        .filter(function () {
            return $(this)
                .attr("href")
                .match(/\.(jpg|jpeg|gif|png|bmp)$/i);
        })
        .fancybox({
            lang: "cs",
            i18n: fancyboxCS,
        });

    // fancyboxes
    $(".fancybox").fancybox({
        lang: "cs",
        i18n: fancyboxCS,
    });

    // manage animated scrolling
    $("body").on("click", "[data-scrollto]", function (e) {
        e.preventDefault();

        var $target = $($(this).attr("data-scrollto"));
        var minus = $(this).attr("data-scrollto-minus");
        if (minus == null) {
            minus = 0;
        }

        animateScroll($target, minus);

        return false;
    });

    // animated scroll for anchor links (removed - handled by newer implementation below)

    $(document).ready(function () {
        $(".searchform").submit(function (e) {
            var $input = $(this).find("input#search");

            if ($input.val().trim() === "") {
                e.preventDefault();
                $input.focus();
                $(this).addClass("is-active");
            } else {
                // Formulář je vyplněný, odešle se
                $(this).removeClass("is-active");
            }
        });

        $(".searchform button[type='submit']").on("click", function (e) {
            e.preventDefault();
            $(".searchform").trigger("submit");
        });
    });

    $(".header__menu-btn").click(function (e) {
        e.preventDefault();
        if ($("header.header nav.menu-primary").hasClass("active")) {
            $(this).removeClass("active");
            $("header.header nav.menu-primary").removeClass("active");
        } else {
            $(this).addClass("active");
            $("header.header nav.menu-primary").addClass("active");
        }
    });

    // mobile menu
    $("#mobileMenu").click(function (e) {
        e.preventDefault();

        if ($("header").hasClass("withMenu")) {
            $("header").removeClass("withMenu");
            $("body,html").removeClass("withMenu");
            $(this).removeClass("is-active");
        } else {
            $("header").addClass("withMenu");
            $("body,html").addClass("withMenu");
            $(this).addClass("is-active");
        }

        return false;
    });
    $("header .menu li.current-menu-parent").addClass("opened");
    $("header .menu li.menu-item-has-children").append("<span></span>");
    $("header .menu span").click(function () {
        if ($(this).parent().hasClass("opened")) {
            $(this).parent().removeClass("opened");
        } else {
            $(this).parent().addClass("opened");
        }
    });
    // $("#mobileMenu").click();

    // $(".site-header__search button").click(function (e) {
    // if ($(".site-header__search").hasClass("active")) {
    // if ($(".site-header__search input[name='s']").val() == "") {
    // e.preventDefault();
    // $(".site-header__search").removeClass("active");
    // }
    // } else {
    // e.preventDefault();
    // $(".site-header__search").addClass("active");
    // }
    // });

    // page scrolled - adjust header
    $(window).scroll(function () {
        if ($(window).scrollTop() > 20) {
            if (!$("header").hasClass("scrolled")) {
                $("header").addClass("scrolled");
            }
        } else {
            $("header").removeClass("scrolled");
        }
    });
    $(window).scroll();

    // Window is loaded or resized
    $(window).on("load resize", function () {
        // Wait until basic transitions ends
        setTimeout(() => {
            // equalizer
            multiEqualizer();
        }, 200);
    });

    // background images
    initBackgrounds();

    // Equalizer right when document loaded
    multiEqualizer();

    $(document).ready(function () {
        function formatSelection(selectedOptions) {
            var count = selectedOptions.length;
            return count === 0 ? "Vyberte" : "Vybráno ";
        }

        function formatResult(data) {
            if (!data.id) {
                return data.text;
            }

            var $result = $(
                '<span><input type="checkbox" class="checkbox-option" /> ' +
                    data.text +
                    "</span>",
            );
            return $result;
        }

        function updateCheckboxes(selectElement) {
            var selectedOptions = $(selectElement).find(":selected");
            var container = $(selectElement)
                .next(".select2-container--open")
                .find(".select2-results__option");

            container.each(function () {
                var $checkbox = $(this).find("input.checkbox-option");
                var value = $(this).data("data").id;

                if (
                    selectedOptions.filter('[value="' + value + '"]').length > 0
                ) {
                    $checkbox.prop("checked", true).addClass("highlight");
                } else {
                    $checkbox.prop("checked", false).removeClass("highlight");
                }
            });
        }

        function updateRenderedSelection(selectElement) {
            var selectedOptions = $(selectElement).find(":selected");
            var count = selectedOptions.length;
            var displayText = formatSelection(selectedOptions);
            var container = $(selectElement)
                .next(".select2-container")
                .find(".select2-selection__rendered");

            if (count > 0) {
                var allSelectedText = $(
                    '<span class="select2-selection__all"></span>',
                ).text("+" + count);
                container.html(displayText).append(allSelectedText);
            } else {
                container.html(displayText);
            }
        }

        function initSelect2() {
            $("select")
                .select2({
                    placeholder: "Vyberte možnost",
                    closeOnSelect: false,
                    templateResult: formatResult,
                    templateSelection: function (data, container) {
                        return data.text;
                    },
                    language: {
                        noResults: function () {
                            return "Nenalezeny žádné výsledky";
                        },
                    },
                })
                .on("change", function (e) {
                    updateRenderedSelection(this);
                    updateCheckboxes(this);
                });

            $("select").each(function () {
                updateRenderedSelection(this);
                updateCheckboxes(this);
            });
        }

        $(document).on("click", ".select2-results__option", function (event) {
            if (!$(event.target).is("input.checkbox-option")) {
                var $checkbox = $(this).find("input.checkbox-option");
                $checkbox
                    .prop("checked", !$checkbox.prop("checked"))
                    .toggleClass("highlight");

                var $option = $(this).data("data").element;
                if ($checkbox.prop("checked")) {
                    $($option).prop("selected", true);
                } else {
                    $($option).prop("selected", false);
                }
                $($option).trigger("change");
            }
        });

        $(document).on("click", "input.checkbox-option", function (event) {
            event.stopPropagation();
            var $checkbox = $(this);
            $checkbox
                .prop("checked", !$checkbox.prop("checked"))
                .toggleClass("highlight");

            var $option = $checkbox
                .closest(".select2-results__option")
                .data("data").element;
            if ($checkbox.prop("checked")) {
                $($option).prop("selected", true);
            } else {
                $($option).prop("selected", false);
            }
            $($option).trigger("change");
        });

        $(document).on("select2:open", function () {
            $("select").each(function () {
                updateCheckboxes(this);
            });
        });

        initSelect2();
    });

    // Iframe ratio fix
    // iframeRatioFix();
});

function initBackgrounds() {
    // background images
    $("[data-background]").each(function () {
        var bg = $(this).attr("data-background");
        if (bg.length > 0) {
            $(this).css("background-image", "url(" + bg + ")");
        }
    });
}

function animateScroll($target, minus) {
    // <summary>
    // Animated scrolling.
    // </summary>
    // <param name="$target" type="element">jQuery element to scroll to.</param>
    // <param name="minus" type="int">Amount of pixels to decrease the position.</param>

    if (minus == null) {
        minus = 0;
    }

    $root.animate(
        {
            scrollTop: $target.offset().top - minus,
        },
        500,
    );
}

// This function initializes multiequalizer
// - container: data-equal="key1,key2", data-equal-on="640"
// - items: data-equal-watch="key1", data-equal-watch="key2"
function multiEqualizer() {
    $("[data-equal]").each(function () {
        var $parent = $(this),
            types = $parent.attr("data-equal").split(","),
            equalOn = $parent.attr("data-equal-on"),
            equalInRow = String(
                $parent.attr("data-equal-in-row"),
            ).toLowerCase();

        if (
            typeof equalOn == "undefined" ||
            window.innerWidth >= parseInt(equalOn)
        ) {
            $.each(types, function (i, e) {
                // Equalize in row
                if (equalInRow === "true" || equalInRow === "1") {
                    // Current item position from top
                    let rowPosY = 0;
                    let rows = [],
                        rowItems = [],
                        rowsH = [];
                    var H = 0;

                    // Prepare array of items in row
                    // Only visible - useful when filtration
                    let items = $parent
                        .find("[data-equal-watch=" + e + "]:visible")
                        .height("auto");

                    items.each(function () {
                        let item = $(this),
                            itemPosY = item.offset().top;
                        if (itemPosY != rowPosY) {
                            rowPosY = itemPosY;
                            // Push only nonempty array (e.g. skip the first)
                            if (rowItems.length > 0) {
                                rows.push(rowItems);
                                rowsH.push(H);
                            }

                            rowItems = [];
                            H = 0;
                        }

                        var h = $(this).height();
                        if (h > H) {
                            H = h;
                        }
                        rowItems.push(item);
                    });

                    // Add final row
                    rows.push(rowItems);
                    rowsH.push(H);
                    rows.forEach(function (row, i) {
                        let H = rowsH[i];
                        row.forEach(function (item) {
                            $(item).height(H);
                        });
                    });

                    // Equalize all
                } else {
                    var H = 0;
                    // Reset the height for proper calculation on resize
                    $parent.find("[data-equal-watch=" + e + "]").height("auto");
                    // Find the highest value
                    $parent
                        .find("[data-equal-watch=" + e + "]")
                        .each(function () {
                            var h = $(this).height();
                            if (h > H) {
                                H = h;
                            }
                        });

                    // Set the highest value to all items
                    $parent.find("[data-equal-watch=" + e + "]").height(H);
                }
            });
        } else {
            $.each(types, function (i, e) {
                $parent.find("[data-equal-watch=" + e + "]").height("auto"); // Reset the height
            });
        }
    });
}

// This function tries to fix iframe aspect ratio
function iframeRatioFix(selector = "") {
    if (!selector) {
        // Set default selector
        selector = ".gutenberg-wrapper iframe";
    }

    // Set proper width, height & aspect ratio for iframes
    let iframes = $(selector);
    if (iframes.length > 0) {
        iframes.each(function () {
            let $iframe = $(this),
                iframeW = parseInt($iframe.attr("width")),
                iframeH = parseInt($iframe.attr("height")),
                aspectRatio;

            if (iframeW && iframeH) {
                aspectRatio = iframeW + "/" + iframeH;
            } else {
                // fallback
                aspectRatio = "500/281";
            }

            $iframe.css({
                width: "100%",
                height: "initial",
                "aspect-ratio": aspectRatio,
            });
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const faqToggles = document.querySelectorAll(".faq-toggle");

    faqToggles.forEach((toggle) => {
        toggle.addEventListener("click", function () {
            const answer = this.nextElementSibling;
            const isOpen = this.getAttribute("aria-expanded") === "true";
            const iconPlus = this.querySelector(".plus");
            const iconMinus = this.querySelector(".minus");

            if (!isOpen) {
                // Open the answer
                answer.style.opacity = "1";
                answer.style.visibility = "visible";
                const height = answer.scrollHeight + "px";
                answer.style.maxHeight = "0";
                answer.style.transition = "max-height 0.4s ease";
                answer.style.margin = "0 0 1.5rem 0";
                setTimeout(() => {
                    answer.style.maxHeight = height;
                }, 10); // Adding a small delay to allow display block to take effect
                this.setAttribute("aria-expanded", "true");

                // Change icon
                iconPlus.style.display = "none";
                iconMinus.style.display = "block";
            } else {
                // Close the answer
                answer.style.maxHeight = "0";
                answer.style.transition = "max-height 0.4s ease";
                answer.style.margin = "0";
                answer.addEventListener(
                    "transitionend",
                    function () {
                        answer.style.opacity = "0";
                        answer.style.visibility = "hidden";
                    },
                    { once: true },
                );
                this.setAttribute("aria-expanded", "false");

                // Change icon
                iconPlus.style.display = "block";
                iconMinus.style.display = "none";
            }
        });
    });
});

var popup = document.getElementById("newsletter-popup");
var btn = document.getElementById("subscribe-button");
var span = document.getElementsByClassName("close")[0];
var footerBtn = document.getElementById("footer-subscribe-button");

function showPopup() {
    popup.classList.add("show");
    popup.classList.remove("hide");
}

function hidePopup() {
    popup.classList.add("hide");
    setTimeout(function () {
        popup.classList.remove("show");
    }, 400);
}

btn.onclick = function () {
    showPopup();
};

if (footerBtn) {
    footerBtn.onclick = function () {
        showPopup();
    };
}

span.onclick = function () {
    hidePopup();
};

window.onclick = function (event) {
    if (event.target == popup) {
        hidePopup();
    }
};

function myFunction() {
    document.getElementById("myDropdown").classList.toggle("show");
}

window.onclick = function (event) {
    if (!event.target.matches(".dropbtn")) {
        var dropdowns = document.getElementsByClassName("dropdown-content");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
            var openDropdown = dropdowns[i];
            if (openDropdown.classList.contains("show")) {
                openDropdown.classList.remove("show");
            }
        }
    }
};

document.addEventListener("DOMContentLoaded", function () {
    var initialRequiredFields = [];

    function storeInitialRequiredFields() {
        setTimeout(function () {
            var inputs = document.querySelectorAll(
                '.container-repeater-field .ginput_container input[aria-required="true"]',
            );
            inputs.forEach(function (input) {
                if (!initialRequiredFields.includes(input.id)) {
                    initialRequiredFields.push(input.id);
                }
            });
        }, 500);
    }

    function reapplyRequiredAttributes() {
        initialRequiredFields.forEach(function (id) {
            var inputField = document.getElementById(id);
            if (inputField) {
                var label = document.querySelector('label[for="' + id + '"]');
                if (inputField.value.trim() === "") {
                    inputField.classList.add("require");
                    inputField.setAttribute("required", "required");
                    if (label) {
                        label.classList.add("require");
                    }
                } else {
                    inputField.classList.remove("require");
                    inputField.removeAttribute("required");
                    if (label) {
                        label.classList.remove("require");
                    }
                }
            }
        });
    }

    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.addedNodes.length || mutation.type === "childList") {
                setTimeout(function () {
                    storeInitialRequiredFields();
                    reapplyRequiredAttributes();
                }, 100);
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });

    // Uložení počátečních required polí
    storeInitialRequiredFields();

    // Při selhání odeslání formuláře přidat třídu "require" a atribut "required"
    document.addEventListener("gform_post_render", function (event) {
        setTimeout(function () {
            reapplyRequiredAttributes();
        }, 100);
    });
});

/*
jQuery(document).ready(function ($) {
    function toggleFields() {
        if ($("#field_1_16").hasClass("checked")) {
            $("#field_1_19, #field_1_18").slideUp();
        } else if ($("#field_1_33").hasClass("checked")) {
            $("#field_1_19, #field_1_18").slideDown();
        } else {
            $("#field_1_19, #field_1_18").slideDown();
        }
    }

    $("#field_1_16, #field_1_33").on("click", function () {
        $(this).toggleClass("checked");

        if ($(this).hasClass("checked")) {
            if (this.id === "field_1_16") {
                $("#field_1_33").removeClass("checked");
            } else {
                $("#field_1_16").removeClass("checked");
            }
        }

        toggleFields();
    });

    toggleFields();
});
*/


document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
        e.preventDefault();

        const targetId = this.getAttribute("href").substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
            // Vypočítat správný offset na základě výšky headeru
            const siteHeader = document.querySelector(".site-header");
            const actionHeader = document.querySelector(".action-header");
            const adminBar = document.querySelector("#wpadminbar");

            let headerOffset = 20; // základní offset

            if (siteHeader) {
                headerOffset += siteHeader.offsetHeight;
            }
            if (
                actionHeader &&
                window.getComputedStyle(actionHeader).display !== "none"
            ) {
                headerOffset += actionHeader.offsetHeight;
            }
            if (adminBar) {
                headerOffset += adminBar.offsetHeight;
            }

            const elementPosition = targetElement.getBoundingClientRect().top;
            const offsetPosition =
                elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const openOrderFormButtons = document.querySelectorAll(".openOrderForm"); // Najdi všechna tlačítka s třídou openOrderForm

    openOrderFormButtons.forEach((button) => {
        button.addEventListener("click", function (event) {
            event.preventDefault(); // Zamezíme výchozímu chování odkazu

            // Předpokládáme, že modální okno se načte zde (nahradíte vlastní logikou)
            const modal = document.getElementById("registerFormModal"); // Změňte ID podle potřeby
            if (modal) {
                modal.classList.add("visible"); // Zobrazíme modal (příklad)

                // Po načtení obsahu inicializujeme logiku formuláře
                initializeFormLogic();
            }
        });
    });

    function initializeFormLogic() {
        const checkboxWrapper = document.querySelector(".icheckbox");
        const checkbox = document.getElementById("choice_1_16_1");
        const fieldsToToggle = document.querySelectorAll(".to-toggle");

        if (!checkboxWrapper || !checkbox) {
            console.error(
                "Checkbox nebo jeho wrapper nebyl nalezen! Zkontrolujte strukturu formuláře.",
            );
            return;
        }

        // Funkce na skrytí/zobrazení polí
        const toggleFields = () => {
            const isChecked = checkboxWrapper.classList.contains("checked");
            console.log("Stav checkboxu:", isChecked);

            fieldsToToggle.forEach((field) => {
                if (isChecked) {
                    field.classList.add("hidden");
                    console.log("Skrývám pole:", field.id);
                } else {
                    field.classList.remove("hidden");
                    console.log("Zobrazuji pole:", field.id);
                }
            });
        };

        // Přidáme listener na wrapper, který Gravity Forms mění
        checkboxWrapper.addEventListener("click", function () {
            // Po kliknutí aktualizujeme stav
            toggleFields();
        });

        // Inicializujeme viditelnost na základě výchozího stavu
        toggleFields();
    }
});

window.addEventListener("load", function () {
    document.getElementById("dynamic-cookies-bar-intro").style.display =
        "block";
});

document.addEventListener("DOMContentLoaded", function () {
    // Získáme URL parametry
    const urlParams = new URLSearchParams(window.location.search);

    // Seznam filtrů, které chceme kontrolovat
    const filterKeys = [
        "forma-kurzu[]",
        "typ-socialni-sluzby[]",
        "zamereni-kurzu[]",
        "typ-kurzu[]",
        "termin[]",
        "course_discount",
        "sort",
        "order",
    ];

    // Zkontrolujeme, zda je přítomen některý z filtrů
    const hasFilters = Array.from(urlParams.keys()).some(
        (key) =>
            filterKeys.includes(key) ||
            key.startsWith("forma-kurzu[") ||
            key.startsWith("typ-socialni-sluzby[") ||
            key.startsWith("zamereni-kurzu[") ||
            key.startsWith("typ-kurzu[") ||
            key.startsWith("termin["),
    );

    // Pokud jsou filtry přítomny, scrollneme na #selected-course s offsetem
    if (hasFilters) {
        const selectedCourseSection =
            document.getElementById("selected-course");
        if (selectedCourseSection) {
            // Výška offsetu (např. 100px nad sekcí)
            const offset = 200;
            const sectionPosition =
                selectedCourseSection.getBoundingClientRect().top +
                window.pageYOffset;
            const scrollPosition = sectionPosition - offset;

            window.scrollTo({
                top: scrollPosition,
                behavior: "smooth",
            });
        }
    }
});
